<template>

  <div class="bg">
    <div class="register">
		<div class="head">
			<i class="van-badge__wrapper van-icon van-icon-cross"  @click="back()"></i>
			<div style="display: flex; align-items: center;">
				<a @click="toLogin()" >{{$t('login.doLogin')}}</a>
				
			</div>
		</div>
		<img src="/img/logo.png" alt="" style="margin: 10px 0px;">
		<form>
			<div class="ipt" >
				<van-icon name="contact" size="1.5rem" color="#999" />
				<input type="text" v-model="username" :placeholder="$t('login.usernamePls')" >
			</div>
			<div class="ipt" >
				<van-icon name="lock" size="1.5rem" color="#999" />
				<input autocomplete=""  :placeholder="$t('register.loginPasswordPls')" v-model="password" :type="passwordType" >
				<van-icon :name=" passwordType === 'password' ? 'closed-eye':'eye-o'" size="1.5rem" color="#999" @click="switchPasswordType"/>
			</div>
			<div class="ipt" >
				<van-icon name="lock" size="1.5rem" color="#999" />
				<input autocomplete=""  :placeholder="$t('register.repasswordPls')" v-model="repassword" :type="repasswordType" >
				<van-icon :name=" repasswordType === 'password' ? 'closed-eye':'eye-o'" size="1.5rem" color="#999" @click="switchrePasswordType"/>
			</div>
			<div class="ipt" >
				<van-icon name="medal-o" size="1.5rem" color="#999" />
				<input type="text" v-model="code" :placeholder="$t('register.codePls')" >
			</div>
		</form>
		<div class="res" >
			<van-checkbox v-model="checked" />
			<a >{{$t('register.xieyi')}}</a>
		</div>
		<div class="btn" :class="btnState==false?'':'active'" @click="doRegister()" >{{$t('register.register')}}</div>
      
    </div>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checked: true,
      username: '',
      code: '',
      password: this.inputValue,
      passwordType: 'password',
	repassword: this.inputValue,
		repasswordType: 'password',
      isSubmitting: false,
    };
  },
  computed:{
         btnState(){
             return this.username!==""&&this.password!==""&&this.repassword!==""&&this.code!==""
         }
     },
  methods: {
    normalizeField(value) {
      return value === null || value === undefined ? '' : String(value).trim();
    },
    async requestRegister(payload) {
      // 首次弱网/冷启动失败时自动重试一次，避免必须手动点两次
      let lastRes = null;
      for (let i = 0; i < 2; i += 1) {
        lastRes = await this.$http({
          method: 'post',
          data: payload,
          url: 'member_register'
        });
        if (lastRes && typeof lastRes.code !== 'undefined') {
          return lastRes;
        }
      }
      return lastRes;
    },
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
	switchrePasswordType() {
		this.repasswordType = this.repasswordType === 'password' ? 'text' : 'password'
	},
	toLogin(){
	  this.$router.push("Login")
	},
    back(){
      return window.history.back();
    },
    async doRegister() {
      if (this.isSubmitting) {
        return false;
      }
      const username = this.normalizeField(this.username);
      const password = this.normalizeField(this.password);
      const repassword = this.normalizeField(this.repassword);
      const code = this.normalizeField(this.code);
      this.username = username;
      this.password = password;
      this.repassword = repassword;
      this.code = code;
      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast(this.$t('login.usernamePls'));
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast(this.$t('register.loginPasswordPls'));
        return false;
      }
	if(this.repassword === "" || this.repassword === null || this.repassword === undefined){
		this.$toast.fail(this.$t('register.repasswordPls'));
		return false;
	}
      if(this.password !== this.repassword){
        this.$toast.fail(this.$t('register.passwordMismatch'));
        return false;
      }
      if(this.code === "" || this.code === null || this.code === undefined){
        this.$toast.fail(this.$t('register.codePls'));
        return false;
      }
      if(!this.checked){
        this.$toast.fail(this.$t('register.xieyiPls'));
        return false;
      }
      this.isSubmitting = true;
      try {
        const res = await this.requestRegister({
          username:this.username,
          password:this.password,
          repassword:this.repassword,
          code:this.code
        });
        if (!res || typeof res.code === 'undefined') {
          this.$toast.fail('網路異常，請稍後重試');
          return false;
        }
          if(res.code === 200){
            const msg = res && res.msg != null && String(res.msg).trim() ? String(res.msg) : '註冊成功';
            this.$toast.success(msg);
            // 註冊成功後視為已登入：把後端返回的 token/id 等寫入 localStorage
            const tokenValue =
              res.data && typeof res.data === 'object'
                ? (res.data.token || res.data.id || res.data.data || '')
                : res.data;
            if (!tokenValue) {
              this.$toast.fail('註冊成功，但登入資訊缺失');
              return;
            }
            localStorage.setItem('token', tokenValue)
            this.$router.push({ path: '/Mine' })
          }else {
            const msg = res && res.msg != null && String(res.msg).trim() ? String(res.msg) : '註冊失敗';
            this.$toast.fail(msg);
          }
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  created() {
    if(localStorage.getItem('token')){
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/basenew.css";

.page {
    gbcolor: linear-gradient(30deg,#7d76ef,#d63f8c)
}

.bg {
    height: 100%;
    background-image: linear-gradient(180deg,#f560cd,#4f2b8a)
}

.register {
    width: 100%;
    height: 100%;
    background: url(../../assets/img/bg.png) no-repeat 50%/100%;
    padding-bottom: 3.33333rem;
    position: relative;
    z-index: 1
}

.register .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4% 3%
}

.register .head i {
    font-size: 1.66667rem;
    color: #fff
}

.register .head a {
    font-size: 1.2rem;
    color: #fff;
    font-weight: 600
}

.register> {
    position: relative;
    z-index: 9
}

/* .register:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(30deg,rgba(125,118,239,.25),rgba(225,70,149,.18));
    left: 0;
    top: 0
} */

.register>img {
    width: 12rem;
    margin-top: .33333rem
}

.register .title {
    font-size: 1.16667rem;
    color: #fff;
    font-weight: 600;
    padding: 1.66667rem 0
}

.register .ipt {
    width: 90%;
    height: 3.66667rem;
    margin: 1rem auto;
    border-radius: .33333rem;
    overflow: hidden;
    background: hsla(0,0%,100%,.85);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 .66667rem
}

.register .ipt input {
    flex: 1;
    height: 100%;
    border: none;
    background: none;
    outline: none;
    text-align: left;
    font-size: .93333rem;
    padding-left: 1rem
}

.register .ipt input::-moz-placeholder {
    font-size: 1rem
}

.register .ipt input::placeholder {
    font-size: 1rem
}

.register .forget {
    width: 100%;
    text-align: right;
    padding: 0 1.33333rem
}

.register .forget a {
    color: #fff;
    font-size: .8rem
}

.register .res {
    width: 100%;
    padding: 0 1.33333rem;
    display: flex;
    justify-content: center;
    align-items: center
}

.register .res a {
    color: #fff;
    font-size: .8rem;
    margin-left: .33333rem
}

.register .btn {
    width: 90%;
    margin: 1.66667rem auto;
    background: #cacacc;
    height: 2.93333rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: .33333rem;
    font-size: 1.06667rem
}

.register .btn.active {
    background: linear-gradient(90deg,#f560cd,#4f2b8a)
}

.register .van-nav-bar {
    background: none
}

.register .van-nav-bar .van-icon {
    color: #fff
}

.register .van-hairline--bottom:after {
    border-width: 0
}

</style>
